import { render } from "./AppTextarea.vue?vue&type=template&id=69ffa552&scoped=true&ts=true"
import script from "./AppTextarea.vue?vue&type=script&lang=ts"
export * from "./AppTextarea.vue?vue&type=script&lang=ts"

import "./AppTextarea.vue?vue&type=style&index=0&id=69ffa552&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ffa552"]])

export default __exports__